// extracted by mini-css-extract-plugin
export default {"status-box":"VolunteerStatus_status-box__2DLU6","status-box-warning":"VolunteerStatus_status-box-warning__9-GwS","status-box-error":"VolunteerStatus_status-box-error__Z8Iu4"};